import { faEye } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function ShowPermissionsButton({ onClick }) {
  return (
    <ColorChangingIcon
      title="Show Permissions"
      icon={faEye}
      initialPrimaryColor="#00aeef"
      initialSecondaryColor="#0078D4"
      initialSize={18}
      hoverSize={18}
      margin="0 0 0 5px"
      onClick={onClick}
    />
  );
}

export default ShowPermissionsButton;
